<template>
  <div class="layout" ref="main">
    <Layout style="min-height: 100vh">
      <Header class="paas-menu-header">
        <div class="header-menu-title" style="color:#3d3d3d">后台管理平台</div>
        <div class="header-menu-nav">
           <div  class="menu-nav-MenuItem">
            <div v-for="(item,index) in menus" :key="item.id" class="nav-MenuItem">
              <MenuItem :name="item.title" v-if="typeof(moduleChildMap[item.id]) === 'undefined'" >
                <span @click="showSideMenu(item.id,'head')" :class="{active:isActive===item.id}"
               >{{item.title}}</span>
              </MenuItem>
              <Dropdown :name="item.title" v-if="typeof(moduleChildMap[item.id]) !== 'undefined' && moduleChildMap[item.id].length !== 0" class="nav-item"
                        trigger="custom"  :visible="index===currindex" @on-clickoutside="currindex=-1">
                <span :class="{active:isActive===item.id}" class="dropDown-item" @click="changeActive(item.id,index)">
                  {{item.title}}
                   <Icon type="ios-arrow-down"></Icon>
                </span>
                <DropdownMenu slot="list" >
                  <DropdownItem v-for="menu in moduleChildMap[item.id]" :key="menu.id"
                                @click.native="showSideMenu(menu.id,'drop')"  :class="{active:isDropActive=== menu.id}" >
                    <Icon :type="menu.icon" color="#2b85e4" ></Icon>
                    {{menu.title}}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
             <Button type="primary" class="login-btn" @click="loginout" style="height:30px;margin-top:10px;">退出登录</Button>
          </div>
        </div>
      </Header>
      <Layout>
         <Sider class="paas-left-menu" width="100" >
           <!--点击左边菜单，子组件传递key数据,此时给router-view中的key属性赋值-->
           <SideMenu :menus="childrenMenu" @changeKeyData="changeKeyData"></SideMenu>
         </Sider>
         <Content  style="min-height:calc( 100vh - 60px );overflow: auto;">
           <keep-alive>
             <router-view v-if="$route.meta.keepAlive"></router-view>
           </keep-alive>
           <router-view v-if="!$route.meta.keepAlive" :key="key" @getKeyChange="changeKeyData"></router-view>
         </Content>
       </Layout>
     </Layout>
   </div>
 </template>

 <script>
   import SideMenu from './menu/side-menu'
   import HeadNav from './menu/re-dropdown'
   export default {
     name: 'Main',
     components:{HeadNav,SideMenu},

     data() {
       return {
         menus:[],
         moduleChildMap:{},
         moduleFuncMap:{},
         childrenMenu:[],

         //modules: [],
         //moduleFunc:[],
         isActive:'',
         isDropActive:'',
         visible:false,
         currindex:-1,
         key:'',
       }
     },
     created() {
       this.menus = this.$store.state.topMenu;
       this.moduleChildMap = this.$store.state.moduleChildMap;
       this.moduleFuncMap = this.$store.state.moduleFuncMap;

       /**
        * 单页面刷新的可能会取不到值
        */
       if(JSON.stringify(this.menus) !== {} && window.localStorage.getItem("topMenu")){
         this.menus = JSON.parse(window.localStorage.getItem("topMenu"));
         this.$store.commit('setTopMenu', this.menus);
       }

       if(JSON.stringify(this.moduleChildMap) !== {} && window.localStorage.getItem("moduleChildMap")){
         this.moduleChildMap = JSON.parse(window.localStorage.getItem("moduleChildMap"));
         this.$store.commit('setModuleChild', this.moduleChildMap);
       }

       //判断map为空JSON.stringify(map) != {}
       if(JSON.stringify(this.moduleFuncMap) !== {} && window.localStorage.getItem("moduleFuncMap")){
         this.moduleFuncMap = JSON.parse(window.localStorage.getItem("moduleFuncMap"));
         this.$store.commit('setModuleFunc', this.moduleFuncMap);
       }

       let firstModule = this.$store.state.firstModule;
       if(JSON.stringify(firstModule) !== {} && window.localStorage.getItem("firstModule")){
         firstModule = JSON.parse(window.localStorage.getItem("firstModule"));
         this.$store.commit('setFirstModule', firstModule);
       }

       let funcOperMap = this.$store.state.funcOperMap;
       if(JSON.stringify(funcOperMap) !== {} && window.localStorage.getItem("funcOperMap")){
         funcOperMap = JSON.parse(window.localStorage.getItem("funcOperMap"));
         this.$store.commit('setFuncOperMap', funcOperMap);
       }

       ;
       let activeId = this.$route.query.paasCurrentFunctionId;
       if(activeId === undefined || activeId === 'undefined' ){
         activeId = this.$store.state.defaultFuncId;
       }
       let currentFunc = funcOperMap[activeId].func;
       let currentModuleId = currentFunc.parentId;

       //给chilrenMenu赋值并选中显示页面
       this.childrenMenu =this.moduleFuncMap[currentModuleId];
       //判断firstModule是一级还是二级,
       for(let j=0;j<this.menus.length;j++){
         if(this.menus[j].id === currentModuleId){
           if(typeof(this.moduleChildMap[this.menus[j].id]) !== "undefined" && this.moduleChildMap[this.menus[j].id].length > 0){
             this.isActive = this.menus[j].parentId;
             this.isDropActive = currentModuleId;
           }else{
             this.isActive = currentModuleId;
           }
         }
       }
       if(this.$route.path === "/main") {
         let firstFunc = this.$store.state.firstFunc;
         if(JSON.stringify(firstFunc) !== {} && window.localStorage.getItem("firstFunc")) {
           firstFunc = JSON.parse(window.localStorage.getItem("firstFunc"));
           this.$store.commit('setFirstFunc', firstFunc);
         }
         let funcUrl = firstFunc.url;
         if(funcUrl) {
           this.$router.push({path: funcUrl})
         }

       }

     },
     methods: {
       loginout() {
           this.$Modal.confirm({
               title: "退出管理平台",
               content: "您确定要退出吗?",
               onOk: () => {
                   this.$router.push({path: "/loginOut"});
                   location.reload();
               },
               onCancel: () => {
                   this.$Message.info('取消模态框');
               }
           })
       },

       //点击headNav，选中Item
       changeActive(id,index){
         this.isActive = id;
         this.currindex = index;
       },

       //点击模块，出现左边菜单
       showSideMenu(id,type){
         for(let key in this.moduleFuncMap){
           if(key === id){
             this.childrenMenu =this.moduleFuncMap[key];
             this.$router.push({path: this.moduleFuncMap[key][0].url})
           }
         }
         if(type==='drop'){
           this.isDropActive = id;
         }else{
           this.isDropActive = '';
           this.isActive = id;
         }
         this.currindex = -1;
       },

       //点击菜单，刷新router-view
       changeKeyData(data){
         this.key = data;
       },
     }
   }

 </script>

 <style  scoped>
   .ivu-layout {
     min-height: auto;
     background: url("/public/image/body.jpg") repeat;
   }
   .paas-menu-header {
     background: url(../../assets/images/backgrounds/top.jpg) repeat-x 0 0;
     height: 48px;
     display: block;
     width: 100%;
     position: absolute;
     z-index: 1000;
     line-height: 48px;
     border-bottom: 1px solid #1c1c1c;
   }
   .header-menu-title{
     float: left;
     letter-spacing: 2px;
     text-align: center;
     font-size: 18px;
     font-weight: 600;
     color: #fff;
     text-shadow: 0 -1px #6f6f6f;
   }
   .header-menu-nav{
     display: block;
     float: right
   }
   .menu-nav-MenuItem{
     display: flex;
     float: right;
   }
   .nav-MenuItem>li{
       margin-right: 30px;
       font-size: 16px;
       line-height: 48px;
       color: #e0e0e0;
       text-shadow: 0 -1px #6f6f6f;
   }
   .nav-item{
     font-size: 16px;
     margin-right: 30px;
     float: right;
     cursor: pointer;
   }
   .dropDown-item{
     color: #e0e0e0;
     text-shadow: 0 -1px #6f6f6f;
   }
   .paas-left-menu {
     background: url(../../assets/images/backgrounds/side.jpg) repeat-y;
     bottom: 0;
     margin-top: 0;
     padding-bottom: 30px;
   }
   .ivu-layout-content{
     flex: auto;
   }
   .ivu-layout-has-sider{
     margin-top: 48px;
   }
   .active{
     color: #46a3ff;
   }
   .whead-right >>>.ivu-btn-text {
     color: #52777b;
   }
   .nav-MenuItem /deep/ .ivu-dropdown-item{
     font-size: 14px!important
   }
 </style>
